<template>
  <div>
    <pre v-if="!hasRunQuery" class="query p-3">
      No query to run, please add a query or toggle run on an existing one.
    </pre>
    <b-table-lite
      striped
      small
      :items="data"
      class="mb-0"
      thead-class="hidden"
      tbody-tr-class="read-row"
      responsive
    >
      <template v-slot:cell(query)="{ item }">
        <pre class="m-2 query">{{ item.query }} </pre>
      </template>
    </b-table-lite>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import omit from 'lodash/omit';
import { mapState, mapGetters } from 'vuex';

export default defineComponent({
  name: 'ReadSummary',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      hasRunQuery: 'read/hasRunQuery',
    }),
    ...mapState({
      sourceType: (state: any) => state.source.type,
      reads: (state: any) => state.read.read,
    }),
    data() {
      return this.reads
        .filter(read => read.run)
        .map(read => omit(read, ['run']));
    },
  },
});
</script>

<style scoped>
.query {
  white-space: pre-line;
}
</style>
